export { default as SimpleRelationshipsGraphCard } from "./SimpleRelationshipsGraphCard";
